export * from './routes';
// TODO refactor consumer api to use coreRoutesApi
export { coreRoutesApi as coreRouterApi } from './routes';
export * from './clientWebRouteMeta/request';
export * from './clientWebRouteMeta/response';
export * from './clientWebRoutesMetaByPage';
export * from './clientWebRoutes/response';
